import { StyleSheet } from 'react-native';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { Spacing } from 'src/theme-v2/spacing';
import { Stroke } from 'src/theme-v2/stroke';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  savingContentContainer: {
    gap: Spacing.Condensed,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderWidth: Stroke.StrokeThickness.StrokeThicknessDefault,
    borderRadius: CornerRadius.Full,
    paddingHorizontal: Spacing.Condensed,
    paddingVertical: Spacing.Condensed,
    borderColor: 'transparent',
  },
  savingContentText: {
    ...textLatoStyleDS.BodyRegularMd,
    color: ColorTypography.TextColorPrimary,
  },
});
